import { render, staticRenderFns } from "./TeuAccount.vue?vue&type=template&id=5db80eb6&scoped=true&"
import script from "./TeuAccount.vue?vue&type=script&lang=js&"
export * from "./TeuAccount.vue?vue&type=script&lang=js&"
import style0 from "./TeuAccount.vue?vue&type=style&index=0&id=5db80eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db80eb6",
  null
  
)

export default component.exports